/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface UsersUserPermissions { 
    add: boolean;
    change: boolean;
    destroy: boolean;
    view: boolean;
    changeUserPermissions: boolean;
}
export const UsersUserPermissions_add_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UsersUserPermissions_change_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UsersUserPermissions_destroy_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UsersUserPermissions_view_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UsersUserPermissions_changeUserPermissions_Validators: ValidatorFn[] =
    [  Validators.required, ];


